export default __webpack_public_path__ + "static/media/certificate-template.f541869b.jpg";